import { render, staticRenderFns } from "./MarketingMerchants.vue?vue&type=template&id=6a1fee78&scoped=true&"
import script from "./MarketingMerchants.vue?vue&type=script&lang=js&"
export * from "./MarketingMerchants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1fee78",
  null
  
)

export default component.exports